export default "__VITE_ASSET__C4BBQJ4V__"